import Marquee from "react-fast-marquee";

const items = [
  "OwnPBX", "AI Voice Agent", "आपका स्वागत है", "Multi-Tenant PBX", "बात करता है",
  "IVR & Call Queues", "Hinglish", "Inbound + Outbound", "मिस्ड कॉल? नहीं।",
  "Browser Softphone", "Call Analytics", "हर कॉल उठाओ", "CDRs & Reporting",
  "Talks back", "Namaste",
];

export const Ribbon = () => (
  <section className="py-16 md:py-24 bg-[#0a0a0a] overflow-hidden" data-testid="marquee-section">
    <Marquee speed={40} gradient={false} autoFill>
      {items.map((t, i) => (
        <span key={i} className="mx-8 font-heading font-medium text-5xl md:text-7xl tracking-tight flex items-center gap-8 leading-[1.5] py-3">
          <span className={i % 2 === 0 ? "text-stroke-light" : "text-white"}>{t}</span>
          <span className="text-white/40 text-4xl">✦</span>
        </span>
      ))}
    </Marquee>
  </section>
);
